import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import prepareColumnValue from './prepareColumnValue';

export default function (ganttTask, column) {
  const taskTypesForColumn = ['project', 'task', 'milestone'];

  const result = {
    text: '',
    value: null,
    toExcel: '',
  };

  if (!column) {
    return result;
  }

  if (!_.includes(taskTypesForColumn, ganttTask.type) || (!ganttTask.parent && column.type !== constants.CUSTOM_COLUMNS_TYPES.number.id)) {
    return result;
  }

  const taskCustomValues = globalStore.getters['columns/getValuesByParams']({
    projectId: ganttTask.gantt_id,
    taskId: ganttTask.id,
    columnId: column.id,
  });

  return prepareColumnValue(result, ganttTask, column, taskCustomValues);
}
